import React from 'react';
import { useIntl } from 'react-intl';
import core from '@gin-betting/core';
import cn from 'classnames';
import { filter, map } from 'lodash';

import { GameLogo } from 'components';
import { usePureSelector } from 'hooks';
import globalMsgs from 'messages';
import type { Analytics } from 'services/analytics';
import { ALL } from '../../../constants';

import './sportTabs.scss';

const {
    entities: {
        selectors: { selectSports },
    },
} = core;

interface Props {
    sports: string[];
    activeSport: string;
    isNarrow: boolean;
    makeHandleChangeSport: (
        sportId: string
    ) => (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    analytics?: Analytics;
}

const SportTabs: React.FC<Props> = ({
    sports,
    activeSport,
    makeHandleChangeSport,
    isNarrow,
    analytics,
}) => {
    const { formatMessage } = useIntl();

    const allSports = usePureSelector(selectSports);
    const sportsIds = filter(sports, sport => sport !== ALL);

    return (
        <div styleName={cn('container', { 'is-narrow': isNarrow })}>
            <div
                styleName={cn('sport all-button ', {
                    active: activeSport === ALL,
                })}
                onClick={makeHandleChangeSport(ALL)}
            >
                <span>{formatMessage(globalMsgs.all)}</span>
            </div>

            {map(sportsIds, sportId => {
                const isActive = activeSport === sportId;
                const sportName = allSports.get(sportId)?.name ?? '';

                return (
                    <div
                        styleName={cn('sport', {
                            active: isActive,
                        })}
                        onClick={makeHandleChangeSport(sportId)}
                        data-category={analytics?.category}
                        data-action={analytics?.action}
                        data-label={sportName}
                        key={sportId}
                    >
                        <div styleName="logo" title={sportName}>
                            <GameLogo gameId={sportId} />

                            {isActive && (
                                <span styleName="name">{sportName}</span>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default React.memo(SportTabs);
